export default {
  initial: { opacity: 0 },
  animate: { transition: { duration: 1.2 }, opacity: 1 },
  exit: { opacity: 0 },
};
